import React from "react";
import { Link } from "react-router-dom";
import { BookOpen, Wrench, FileText, ChevronRight } from "lucide-react";

const RESOURCES = [
  {
    title: "Tag 101",
    desc: "A primer on NFC tag types \u2014 NFC Forum Type 1 through 5 and MIFARE Classic.",
    href: "/tag-101",
    icon: BookOpen,
    external: false,
  },
  {
    title: "Development Kits",
    desc: "SDKs and example code for Android, iOS, Windows, and JavaScript.",
    href: "/development-kits",
    icon: Wrench,
    external: false,
  },
  {
    title: "White Papers",
    desc: "Technical white papers and application notes on NFC solutions.",
    href: "/white-papers",
    icon: FileText,
    external: false,
  },
];

export default function Resources() {
  return (
    <div>
      <section className="bg-[#f4f5f7] py-14 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-6 lg:px-10">
          <h1 className="text-4xl font-semibold text-slate-800">Resources</h1>
        </div>
      </section>

      <div className="max-w-5xl mx-auto px-6 lg:px-10 py-16">
        <div className="space-y-4">
          {RESOURCES.map((r) => {
            const Icon = r.icon;
            const content = (
              <>
                <div className="w-14 h-14 rounded-full bg-[#29abe2]/10 flex items-center justify-center flex-shrink-0">
                  <Icon className="w-6 h-6 text-[#29abe2]" />
                </div>
                <div className="flex-1">
                  <h3 className="text-xl font-semibold text-slate-800 group-hover:text-[#29abe2] transition-colors">
                    {r.title}
                  </h3>
                  <p className="text-slate-600 text-[15px] mt-1 leading-relaxed">{r.desc}</p>
                </div>
                <ChevronRight className="w-5 h-5 text-slate-400 group-hover:text-[#29abe2] group-hover:translate-x-1 transition-all flex-shrink-0" />
              </>
            );

            const className =
              "group flex items-center gap-5 bg-white border border-slate-200 rounded-md p-5 hover:border-[#29abe2] hover:shadow-md transition-all";

            return r.external ? (
              <a key={r.title} href={r.href} target="_blank" rel="noopener noreferrer" className={className}>
                {content}
              </a>
            ) : (
              <Link key={r.title} to={r.href} className={className}>
                {content}
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
}
